import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": /*@__PURE__*/_normalizeClass(['toolbar-item-container-uni-title'])
};
import { ref } from "../../../../adapter-vue";
import Icon from "../../../common/Icon.vue";
import BottomPopup from "../../../common/BottomPopup/index.vue";
import { isPC, isUniFrameWork } from "../../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    iconFile: {
      type: String,
      required: true
    },
    title: {
      type: String,
      "default": ""
    },
    needDialog: {
      type: Boolean,
      "default": true
    },
    iconWidth: {
      type: String,
      "default": "20px"
    },
    iconHeight: {
      type: String,
      "default": "20px"
    },
    // 是否需要移动端底部弹窗对话框展示, 默认为false
    // pc端无效
    needBottomPopup: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["onIconClick", "onDialogClose", "onDialogShow"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var showDialog = ref(false);
    var toolbarItemRef = ref();
    var dialogRef = ref();
    var toggleToolbarItem = function toggleToolbarItem() {
      emits("onIconClick", dialogRef);
      if (isPC) {
        onClickOutside(toolbarItemRef.value);
      }
      if (!props.needDialog) {
        return;
      }
      showDialog.value = true;
      emits("onDialogShow", dialogRef);
    };
    // click outside
    var clickOutside = false;
    var clickInner = false;
    var onClickOutside = function onClickOutside(component) {
      if (isUniFrameWork) {
        return;
      }
      document.addEventListener("click", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.addEventListener) && (component === null || component === void 0 ? void 0 : component.addEventListener("click", onClickTarget));
    };
    var onClickDocument = function onClickDocument() {
      clickOutside = true;
      if (!clickInner && clickOutside) {
        showDialog.value = false;
        removeClickListener(dialogRef.value);
        emits("onDialogClose", dialogRef);
      }
      clickOutside = false;
      clickInner = false;
    };
    var onClickTarget = function onClickTarget() {
      clickInner = true;
    };
    var removeClickListener = function removeClickListener(component) {
      if (isUniFrameWork) {
        return;
      }
      document.removeEventListener("click", onClickDocument);
      (component === null || component === void 0 ? void 0 : component.removeEventListener) && (component === null || component === void 0 ? void 0 : component.removeEventListener("click", onClickTarget));
    };
    var toggleDialogDisplay = function toggleDialogDisplay(showStatus) {
      showDialog.value = showStatus;
      switch (showStatus) {
        case true:
          emits("onDialogShow", dialogRef);
          break;
        case false:
          emits("onDialogClose", dialogRef);
      }
    };
    var onPopupClose = function onPopupClose() {
      showDialog.value = false;
    };
    __expose({
      toggleDialogDisplay: toggleDialogDisplay
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['toolbar-item-container', !_unref(isPC) && 'toolbar-item-container-h5', _unref(isUniFrameWork) && 'toolbar-item-container-uni']),
        ref_key: "toolbarItemRef",
        ref: toolbarItemRef
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['toolbar-item-container-icon', !_unref(isPC) && 'toolbar-item-container-h5-icon', _unref(isUniFrameWork) && 'toolbar-item-container-uni-icon']),
        onClick: toggleToolbarItem
      }, [_createVNode(Icon, {
        file: props.iconFile,
        "class": "icon",
        width: props.iconWidth,
        height: props.iconHeight
      }, null, 8, ["file", "width", "height"])], 2), _unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.title), 1)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
        ref_key: "dialogRef",
        ref: dialogRef,
        "class": _normalizeClass(['toolbar-item-container-dialog', !_unref(isPC) && 'toolbar-item-container-h5-dialog', _unref(isUniFrameWork) && 'toolbar-item-container-uni-dialog'])
      }, [props.needBottomPopup && !_unref(isPC) ? (_openBlock(), _createBlock(BottomPopup, {
        key: 0,
        show: _unref(showDialog),
        onOnClose: onPopupClose
      }, {
        "default": _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["show"])) : _renderSlot(_ctx.$slots, "default", {
        key: 1
      })], 2), [[_vShow, _unref(showDialog)]])], 2);
    };
  }
});